export enum SiteRFPStatusAPIResponse {
  EngagementLetter = 'engagementLetter',
  PreRFP = 'preRFP',
  RFP = 'rfp',
  Contracts = 'contracts',
  PreNTP = 'preNTP',
  Construction = 'construction',
  Complete = 'complete',
  ConsultingComplete = 'consultingComplete',
}
